import React from 'react';
import { getLessonTypeChipClass } from '@/components/Dashboard/lessonTypeChipClass';

interface Props {
  name: string;
  lessonTypeId: string;
  className?: string;
}

export const LessonTypeChip: React.FC<Props> = ({
  name,
  lessonTypeId,
  className,
}) => (
  <span
    className={`text-caption-12 min-w-0 truncate rounded-xl px-2 py-0.5 tracking-[0.025em] text-foreground ${getLessonTypeChipClass(lessonTypeId)} ${className ?? ''}`}
  >
    {name}
  </span>
);
